import { fileDownload, get as apiGet } from 'api'

export const getDespatch = async documentId => apiGet(`/DespatchAdvices/GetDespatch/${documentId}`)

export const getReceipt = async documentId => apiGet(`/DespatchAdvices/GetReceipt/${documentId}`)

export const downloadPdf = async (documentId, documentType) =>
  fileDownload(`/DespatchAdvices/${documentId}/PDF/Download`, { documentType })

export const downloadXml = async (documentId, documentType) =>
  fileDownload(`/DespatchAdvices/${documentId}/XML/Download`, { documentType })

export const downloadSignature = async (documentId, documentType) =>
  fileDownload(`/DespatchAdvices/${documentId}/DigitalSignature/Download`, { documentType })

export const downloadQrCode = async (documentId, documentType) =>
  fileDownload(`/DespatchAdvices/${documentId}/qr/Download`, { documentType })

export const downloadAttachment = async (documentId, documentType, fileName) =>
  fileDownload(`/DespatchAdvices/${documentId}/attachments/download`, { documentType, fileName })

export const getActions = async (documentId, documentType) =>
  apiGet(`/DespatchAdvices/${documentId}/GetActions`, { documentType })
